import { Conversation } from "../types/chat";

const STORAGE_KEY = "copilot_conversations";
const ACTIVE_KEY = "copilot_active_conversation_id";

/** localStorage adapter — swap for API/database in production. */
export const conversationStorage = {
  loadAll(): Conversation[] {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return [];
      const parsed = JSON.parse(raw) as Conversation[];
      return parsed.map(reviveConversation);
    } catch {
      return [];
    }
  },

  saveAll(conversations: Conversation[]): void {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(conversations));
  },

  getActiveId(): string | null {
    return localStorage.getItem(ACTIVE_KEY);
  },

  setActiveId(id: string): void {
    localStorage.setItem(ACTIVE_KEY, id);
  },

  clearActiveId(): void {
    localStorage.removeItem(ACTIVE_KEY);
  },
};

function reviveConversation(c: Conversation): Conversation {
  return {
    ...c,
    messages: c.messages.map((m) => ({
      ...m,
      timestamp: new Date(m.timestamp),
    })),
  };
}

export function conversationTitle(c: Conversation): string {
  const firstUser = c.messages.find((m) => m.role === "user");
  if (firstUser) {
    return firstUser.content.length > 48
      ? firstUser.content.slice(0, 48) + "…"
      : firstUser.content;
  }
  if (c.customerName) return c.customerName;
  return "New conversation";
}
